<app-ads-svg-symbols></app-ads-svg-symbols>
@if (isAuthenticated) {
  <div class="o-flexbody__body">
    <header
      class="page-head page-head--full [ page-head--box-shadow page-head--sticky ]"
      >
      <div class="o-wrapper">
        <nav
          class="site-nav site-nav--main"
          [ngClass]="{ 'show-mobile-nav': isMenuOpen }"
          role="navigation"
          aria-label="Main navigation"
          >
          <div class="site-nav__branding">
            <div class="site-nav__logo">
              <img
                class="werewolf-logo"
                src="../assets/images/werewolf-logo.png"
                alt="werewolf-logo"
                />
            </div>
          </div>
          <ul class="site-nav__list nav">
            <button class="nav_btn" (click)="hmeOpen()">HME Consent</button>
            <button class="nav_btn" (click)="triggerOpen()">
              Trigger Survey
            </button>
            <button class="nav_btn" [routerLink]="['/survey-response']">
              Survey Response
            </button>
            <button class="nav_btn" [routerLink]="['/patient-search']">
              Profile Search
            </button>
          </ul>
          <ul class="site-nav__list nav">
            <li class="site-nav__item u-show-below-tablet">
              <a href="#logout" class="site-nav__link"><span>Logout</span></a>
            </li>
          </ul>
          <ul class="site-nav__list site-nav--metamenu">
            <li class="site-nav__item">
              <a
                class="site-nav__link [ has-menu-icon has-sub-menu u-hide-below-tablet ] [ js-no-click ]"
                >
                <span>{{ common.name }}</span>
              </a>
              <ul class="site-nav__sub-menu is-last">
                <li class="site-nav__item" (click)="common.logout()">
                  <a class="site-nav__sub-link"><span>Logout</span></a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </header>
    <div class="o-flexbody__page-layout">
      <router-outlet></router-outlet>
    </div>
    @if (isAuthenticated) {
      <footer
        id="footer"
        class="page-footer page-footer--full"
        role="contentinfo"
        >
        <div class="o-wrapper">
          <div class="o-layout">
            <div class="o-layout__item u-1/2@tablet">
              <span class="c-logo c-logo--resmed">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 274.56 199.44">
                  <path
                    d="M46.9,171.72a13.56,13.56,0,0,1-3.26,3.89c-1.6,1.18-3.27,1.94-7.09,3.26l8,19.46H31.2l-6.46-17.59H16.19l-4,17.59H0l11.11-49.06H32.73c1,0,2,0,3.05.07A15.64,15.64,0,0,1,43.56,152c2.16,1.52,5.43,4.79,5.43,11.53a17.14,17.14,0,0,1-2.09,8.2M35.78,160.39c-1.25-1.6-2.7-2.15-6.18-2.15H21.33l-3.06,13.41H28.56a18.28,18.28,0,0,0,2.64-.28,6.52,6.52,0,0,0,4.58-3.48,8.18,8.18,0,0,0,1-4.1,5.33,5.33,0,0,0-1-3.4m85.7,9.59a17.78,17.78,0,0,0-2-3c-2.37-2.71-6.47-5.77-14.73-5.77-8.06,0-12.37,3.13-14.32,6.19a8.88,8.88,0,0,0-.2,9.87c2.15,3.46,5.2,4.51,12.29,6.73,2.5.77,4,1.18,4.86,2.36a2.19,2.19,0,0,1,.42,1.25,2.45,2.45,0,0,1-.42,1.33,3.49,3.49,0,0,1-1.94,1.32,12.38,12.38,0,0,1-3.47.56A10.09,10.09,0,0,1,94,187.56a16.12,16.12,0,0,1-1.32-2.08l-9,4.44A16,16,0,0,0,86,193.18c5.28,6.12,12.63,6.26,15.21,6.26,7.3,0,11.74-2.51,14-4.66a11.37,11.37,0,0,0,3.76-8.05,9.76,9.76,0,0,0-.48-3.2c-1.26-3.69-4.8-5.42-8.41-6.74-1.46-.56-2.93-1-4.45-1.4-3.13-.89-5.63-1.52-5.63-3.47,0-1.52,1.59-2.78,4.58-2.78a10.36,10.36,0,0,1,6.75,2.29,13.51,13.51,0,0,1,2,2.51Zm62.82-20.71H165.89l-15.23,32.17-.83-32.17H131.7l-11,49.06h11.46l8.41-38.49L142,198.33h10.28l18.35-37.94-8.76,37.94h11.4ZM252,198.33h-10.7l.49-2.5c-.57.41-1.12.76-1.67,1.18a14.29,14.29,0,0,1-7.93,2.29,11.42,11.42,0,0,1-7.71-2.71c-2.29-1.88-5.07-5.35-5.07-12.37a27.13,27.13,0,0,1,4-14c4.86-7.64,11.61-8.82,15-8.82a13.24,13.24,0,0,1,7.78,2.37,10.83,10.83,0,0,1,2.31,2.5l3.81-17h10.77Zm-6.46-24.46a5.82,5.82,0,0,0-5.91-4.1,7,7,0,0,0-3.75,1.32c-4,2.64-5.7,8.41-5.7,12.92a8.42,8.42,0,0,0,1.18,4.8,5.11,5.11,0,0,0,4.73,2.36c1.73,0,4.64-.56,7-4.09a20.83,20.83,0,0,0,2.84-10.23,8.53,8.53,0,0,0-.41-3M84.23,182.34c.14-1.52.28-3.12.28-4.72a20.16,20.16,0,0,0-.7-5.56,13.82,13.82,0,0,0-2.63-5.14c-4.31-5.35-10.91-5.62-13.13-5.62a20.6,20.6,0,0,0-10.7,2.85,21.86,21.86,0,0,0-9.11,13.12,19.58,19.58,0,0,0-.55,4.87c0,6.94,3.33,13.2,9.73,15.84a20.7,20.7,0,0,0,7.7,1.39c8.83,0,13.21-4.1,15.36-6.88.62-.82,1.2-1.68,1.76-2.57l-8.33-4.14a16.64,16.64,0,0,1-1.77,2.54,9.4,9.4,0,0,1-6.73,2.78,7.77,7.77,0,0,1-4-1c-3.83-2.09-3.27-6.81-3.2-7.79Zm-21.4-11.53a7.76,7.76,0,0,1,5.28-2,6.64,6.64,0,0,1,6.46,4.1,9.76,9.76,0,0,1,.35,2.71H59.58c1.31-2.85,2-3.69,3.25-4.8m19.41,19.11h0Zm134.68-7.58c.15-1.52.29-3.12.29-4.72a20.16,20.16,0,0,0-.7-5.56,14,14,0,0,0-2.64-5.14c-4.31-5.35-10.91-5.62-13.13-5.62a20.6,20.6,0,0,0-10.7,2.85,21.8,21.8,0,0,0-9.1,13.12,19.25,19.25,0,0,0-.56,4.87c0,6.94,3.34,13.2,9.73,15.84a20.72,20.72,0,0,0,7.71,1.39c8.83,0,13.2-4.1,15.36-6.88.61-.82,1.19-1.68,1.75-2.57l-8.33-4.14a16.59,16.59,0,0,1-1.76,2.54,9.44,9.44,0,0,1-6.74,2.78,7.72,7.72,0,0,1-4-1c-3.83-2.09-3.28-6.81-3.21-7.79Zm-21.4-11.53a7.77,7.77,0,0,1,5.29-2,6.65,6.65,0,0,1,6.46,4.1,10,10,0,0,1,.34,2.71H192.27c1.31-2.85,2-3.69,3.25-4.8m19.42,19.11h0Zm59.61-110a9.09,9.09,0,1,0-8.64,9.5,9.08,9.08,0,0,0,8.64-9.5M259,96.53a8.17,8.17,0,1,0-7.78,8.56A8.17,8.17,0,0,0,259,96.53m-17.14,12.24a7.36,7.36,0,1,0-7,7.71,7.35,7.35,0,0,0,7-7.71m-18.19,7a6.62,6.62,0,1,0-6.3,6.92,6.63,6.63,0,0,0,6.3-6.92m-18,1.17a6,6,0,1,0-5.67,6.23,6,6,0,0,0,5.67-6.23m-16-4.75a5.37,5.37,0,1,0-5.11,5.61,5.39,5.39,0,0,0,5.11-5.61m-12.92-8.48a4.83,4.83,0,1,0-4.59,5,4.82,4.82,0,0,0,4.59-5M166.61,93.5a4.34,4.34,0,1,0-4.13,4.55,4.33,4.33,0,0,0,4.13-4.55m-8-10.71a3.91,3.91,0,1,0-3.73,4.09,3.91,3.91,0,0,0,3.73-4.09M152.32,72A3.52,3.52,0,1,0,149,75.73,3.51,3.51,0,0,0,152.32,72m-4.85-10.46a3.2,3.2,0,1,0-3.2,3.19,3.19,3.19,0,0,0,3.2-3.19M0,63.21A10.2,10.2,0,1,0,10.2,53,10.19,10.19,0,0,0,0,63.21m14-20a9.09,9.09,0,1,0,8.64-9.5A9.09,9.09,0,0,0,14,43.22M29.57,26.61a8.17,8.17,0,1,0,7.77-8.55,8.16,8.16,0,0,0-7.77,8.55M46.7,14.36a7.36,7.36,0,1,0,7-7.7,7.36,7.36,0,0,0-7,7.7M64.9,7.41A6.62,6.62,0,1,0,71.2.48a6.63,6.63,0,0,0-6.3,6.93m18-1.17A6,6,0,1,0,88.58,0a6,6,0,0,0-5.67,6.23m16,4.75A5.37,5.37,0,1,0,104,5.37,5.37,5.37,0,0,0,98.91,11m12.91,8.47a4.83,4.83,0,1,0,4.59-5.05,4.84,4.84,0,0,0-4.59,5.05m10.11,10.18a4.34,4.34,0,1,0,4.13-4.54,4.34,4.34,0,0,0-4.13,4.54m8,10.71a3.91,3.91,0,1,0,3.72-4.09,3.9,3.9,0,0,0-3.72,4.09m6.29,10.74a3.52,3.52,0,1,0,3.35-3.68,3.52,3.52,0,0,0-3.35,3.68"
                    />
                </svg>
              </span>
            </div>
            <div class="o-layout__item page-footer__copyright u-1/2@tablet">
              <p>
                <span>&copy; 2000-2024 ResMed.</span>&nbsp;<span
                >All rights reserved.</span
                >
              </p>
            </div>
          </div>
        </div>
      </footer>
    }
  </div>
}

@if (!isAuthenticated) {
  <router-outlet></router-outlet>
}
